module.exports = __webpack_public_path__ + "assets/img/block-left-hover-fc7531a4.png";